import { defineStore } from "pinia";
import { fetchWithAuth } from "./authFetch";

export const useAuthStore = defineStore("auth", {
    state: () => ({
        user: null, // Global user state
        userReady: false
    }),
    actions: {
        async fetchUser() {
            try {
                const response = await fetchWithAuth("/auth/current-user", { credentials: "include" });
                if (response?.ok) {
                    const user = await response.json();
                    this.user = user;

                    //setupFirebasePush();
                    this.userReady = true;
                    return user;
                }
            } catch (err) {
                console.error("Error fetching user:", err);
            }

            this.user = null;
            this.userReady = true;
            return null;
        },
        async logout() {
            this.user = null;
            await fetch("/auth/logout", { method: "POST", credentials: "include" });
            localStorage.removeItem("jwt"); // Remove token
            localStorage.removeItem("refreshtoken"); // Remove token
            //im going to keep the fcm_token so i dont need to reask for permission.
        }
    }
});
